import useBreakpoint from 'hooks/useBreakpoint';

const useBreakpointView = (breakpoints = ['xs', 'sm']) => {
  const { breakpoint, width } = useBreakpoint();

  const isCustomBreakpoints =
    Array.isArray(breakpoints) && breakpoints.every((val) => typeof val === 'number');

  if (breakpoint === null || width === null) {
    return null;
  }

  if (isCustomBreakpoints) {
    const [min, max] = breakpoints.length === 2 ? breakpoints : [breakpoints[0], Infinity];

    return width >= min && width <= max;
  }

  return breakpoints.includes(breakpoint);
};

export default useBreakpointView;
